<template>
  <header :class="$style.root">

    <slot name="prev" />

    <h1 :class="$style.heading">
      {{ year }}
    </h1>

    <slot name="next" />
  </header>
</template>

<script lang="ts" setup>
  const props = defineProps({
    year: Number
  })
</script>

<style module>
  .root {
    composes: container from global;

    display: flex;
    justify-content: flex-end;
    gap: var(--unit--spacer);

    user-select: none;
  }

  .heading {
    composes: reset-heading font-size-x-large from global;
    text-align: right;
  }

  .nav {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: var(--stroke--medium);
  }
</style>
